
import './App.css';
import React from "react";
import DatabaseModellingTool from "./Components/ContentManagement/DatabaseModellingTool";

function App() {

  return (

    <div className="App">

      <DatabaseModellingTool/>

    </div>
  )
}


export default App;
